import { gql } from '@apollo/client';

const saveSellerInputProgress = gql`
  mutation SaveSellerInputProgress($sellerInputUUID: String!, $email: String!) {
    reception {
      saveSellerInputProgress(input: { uuid: $sellerInputUUID, email: $email }) {
        _empty
      }
    }
  }
`;

export default saveSellerInputProgress;
